import { render, staticRenderFns } from "./OrganizeCollaboration.vue?vue&type=template&id=58cd4c94&scoped=true"
import script from "./OrganizeCollaboration.vue?vue&type=script&lang=js"
export * from "./OrganizeCollaboration.vue?vue&type=script&lang=js"
import style0 from "./OrganizeCollaboration.vue?vue&type=style&index=0&id=58cd4c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd4c94",
  null
  
)

export default component.exports